;(window.HB = window.HB || {}).unwrapElement = function (element) {
  requestAnimationFrame(() => {
    while (element.firstChild) {
      const firstChild = element.firstChild
      element.parentNode.insertBefore(firstChild, element)
    }
    element.remove()
  })
}
